import ExaminerCheatSheet from './ExaminerCheatSheet';

const config = {
  subjectKey: 'science',
  path: '/gcse-science-examiner-tips',
  crumbLabel: 'GCSE Science Examiner Tips',
  appHubPath: '/gcse-science-revision',
  appHubLabel: 'GCSE Science revision',
  seoTitle: 'GCSE Science Examiner Tips Cheat Sheet (AQA Biology, Chemistry, Physics)',
  seoDescription:
    'Free printable GCSE Science cheat sheet. AQA examiner tips for Biology B1-B7, Chemistry C1-C10, Physics P1-P7. Required Practicals, 6-mark exam questions, Grade-9 moves.',
  h1: 'GCSE Science Examiner Tips — Bio, Chem & Physics on one page',
  heroLede:
    'Print this once. Stick it on the wall. Cell biology, vaccination, Group 0, electromagnetic spectrum and more — each topic gets four AQA-aligned blocks: why marks are lost, what examiners want, common traps and the Grade-9 move.',
  related: [
    { href: '/gcse-science-revision',                 testid: 'science-hub',          kicker: 'Subject hub',  title: 'Full GCSE Science revision guide' },
    { href: '/gcse-required-practicals',              testid: 'required-practicals',  kicker: 'Subject hub',  title: 'GCSE Required Practicals (all 16)' },
    { href: '/gcse-maths-examiner-tips',              testid: 'maths-tips',           kicker: 'Cheat sheet',  title: 'GCSE Maths Examiner Tips' },
    { href: '/gcse-english-examiner-tips',            testid: 'english-tips',         kicker: 'Cheat sheet',  title: 'GCSE English Examiner Tips' },
  ],
};

export default function GCSEScienceExaminerTips() {
  return <ExaminerCheatSheet config={config} />;
}
